<template>
    <div>
        <div class="table-wrapper">
            <table class="table notification-table">
                <thead>
                    <tr>
                        <th v-for="(col,inCol) in tableColumns" v-bind:key="inCol" v-show="col.type!=='id'">
                            {{col.label}}
                        </th>
                    </tr>
                </thead>
                <tbody>
                    <tr  v-for="(row,inRow) in tableRows" v-bind:key="inRow" @click="openCard(row._id.$oid)" :class="{read:row['isRead']}">
                        <td v-for="(col,inCol) in tableColumns" v-bind:key="inCol" v-show="col.type!=='id'">
                            <span v-if="col.type=='readInfo'" :class="{'text-success':row[col.prop]==false,'text-read':row[col.prop]==true}"><i class="fa fa-circle"></i></span>
                            <span v-else>{{formatColumn(row[col.prop],col.type)}}</span>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>
<script>
import { mapGetters } from 'vuex'

export default {
    name:"notification-table",
    props:['tableColumns','tableRows','cardType'],
    data() {
        return {
            
        }
    },
    computed: {
        ...mapGetters(['users'])
    },
    methods: {
        formatColumn(data,type){
            if(type=="date"){
                return this.$moment(data.$date).format("DD.MM.YYYY")
            }else if(type=="reminderDate"){
                return this.$moment(data).format("DD.MM.YYYY,HH:mm")
            }else if(type=="organization"){
                return data.name
            }else if(type=="organizationArray"){
                console.log(data)
                if(data!==undefined){
                    return data[0].name
                }else{
                    return ''
                }
            }else if(type=="user"){
                const user = this.users.filter(e => { 
                    return e._id.$oid==data.$oid
                })[0]
                return user.name+" "+user.surName
            }else if(type=="activityType"){
                var activityType={ 1:this.$ml.get('CALL'),2:this.$ml.get('APPOINTMENT'),3:this.$ml.get('TASK'),4:this.$ml.get('E_MAIL')}
                return activityType[data]
            }
            return data
        },
        openCard(id){
            var form={}
            form.cardType = this.cardType
            form.id = id
            this.$emit('openCard',form)
        }
    },
}
</script>
<style scoped>
    @import url("https://maxcdn.bootstrapcdn.com/font-awesome/4.7.0/css/font-awesome.min.css");
    .table-wrapper{
        border:0.5px solid #AFC2D9;
        border-radius: 0.5rem;
        background-color:#ffffff;
        max-height: calc(100vh - 181px);
        overflow: scroll;
    }
    .table-wrapper thead th { 
        position: sticky;
        top: 0;
        background-color:#ffffff;
    }
    .notification-table {
        border-spacing: 0;
        width: 100%;
        margin-bottom:1rem;
    }
    .notification-table thead tr:last-child{
        width: 50px;
        text-align: center;
    }
    .notification-table thead th {
        text-align: left;
        font-size: 12px;
        color: #7E8086;
        border-top: 0;
    }
    .notification-table tbody tr{
        background-color: #F4F4F4;
        border-bottom: 1px solid #AFC2D9;
        cursor: pointer;
        color: #53565E;
    }
    .notification-table tbody tr:hover{
        background-color: #DEDFE1!important;
    }
    .notification-table tbody tr:last-child{
        border-bottom:0;
    }
    .notification-table tbody tr.read {
        background-color: #FAFAFA;
    }
    .text-read{
        color: #AEBCCD;
    }
</style>